import { createReducer, on } from "@ngrx/store";
import { initialWrittenAssignmentRecordState, WrittenAssignmentRecordState } from "./written-assignment-record.state";
import { GetWrittenAssignmentRecords, GetWrittenAssignmentRecordsError, GetWrittenAssignmentRecordsSuccess, ViewWrittenAssignmentRecords } from "./written-assignment-record.actions";

export const WrittenAssignmentRecordsReducers = createReducer(
  initialWrittenAssignmentRecordState,
  on(GetWrittenAssignmentRecords, (state): WrittenAssignmentRecordState => {
    return {
      ...state,
      loading: true,
      result: [],
      error: null
    }
  }),
  on(ViewWrittenAssignmentRecords, (state): WrittenAssignmentRecordState => {
    return {
      ...state,
      loading: true,
      result: [],
      error: null
    }
  }),
  on(GetWrittenAssignmentRecordsSuccess, (state, action): WrittenAssignmentRecordState => {
    return {
      ...state,
      loading: false,
      result: action.result,
    }
  }),
  on(GetWrittenAssignmentRecordsError, (state, action): WrittenAssignmentRecordState => {
    return {
      ...state,
      loading: false,
      error: action.error
    }
  }),
)